import { OperationId } from './../../../operation/store/operation.model';
import { OperationCadragePilotageFormComponent } from './../operation-cadrage-pilotage-form/operation-cadrage-pilotage-form.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { OperationCadrage } from './../../store/operation-cadrage.model';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewContainerRef,
} from '@angular/core';
import { Update } from '@ngrx/entity';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-operation-cadrage-pilotage',
  templateUrl: './operation-cadrage-pilotage.component.html',
  styleUrls: ['./operation-cadrage-pilotage.component.scss'],
})
export class OperationCadragePilotageComponent implements OnInit {
  modalWidth: number = 650;
  editing$ = new BehaviorSubject<boolean>(false);
  editingListItem$ = new BehaviorSubject<any>(null);
  editingListItemShow$ = new BehaviorSubject<any>(null);

  @Input() cadrage: OperationCadrage | any = null;
  @Input() operation: OperationId | any = null;
  @Input() entites: any = null;

  @Output() update: EventEmitter<Update<OperationCadrage>> = new EventEmitter();

  constructor(
    private modal: NzModalService,
    private viewContainerRef: ViewContainerRef
  ) {}

  ngOnInit(): void {}

  onNew(cadrage: OperationCadrage, operation: OperationId, plan?: any): void {
    const modal = this.modal.create({
      nzContent: OperationCadragePilotageFormComponent,
      nzViewContainerRef: this.viewContainerRef,
      nzWidth: this.modalWidth,
      nzFooter: [],
      nzTitle: plan
        ? `Modifier l'instance : ${plan.title}`
        : `Nouvelle instance de pilotage`,
      nzComponentParams: {},
      nzCloseIcon: '',
      nzClosable: false,
    });
    const instance = modal.getContentComponent();
    instance.updateItem$ = new BehaviorSubject<any>(plan);
    instance.operation = operation;
    instance.cancel.subscribe((event: any): any => {
      if (!event) {
        return null;
      } else {
        modal.close();
      }
    });
    instance.add.subscribe((event: any): any => {
      if (!event) {
        return null;
      } else {
        this.onAdd(cadrage, event);
        modal.close();
      }
    });
    instance.update.subscribe((event: any): any => {
      if (!event) {
        return null;
      } else {
        this.onUpdate(cadrage, event);
        modal.close();
      }
    });
  }

  onAdd(cadrage: OperationCadrage, item: any): void {
    const items = cadrage?.pilotage?.length
      ? [...cadrage.pilotage, item]
      : [item];

    const newCadrage: Update<OperationCadrage> = {
      id: cadrage.id,
      changes: {
        ...cadrage,
        pilotage: items,
      },
    };

    this.update.emit(newCadrage);
  }

  onUpdate(cadrage: OperationCadrage, item: any): void {
    const items = cadrage?.pilotage.filter((element) => element.id !== item.id);

    const newCadrage: Update<OperationCadrage> = {
      id: cadrage.id,
      changes: {
        ...cadrage,
        pilotage: [...items, item],
      },
    };

    this.update.emit(newCadrage);
  }

  outputUpdate(cadrage: Update<OperationCadrage>): void {
    this.update.emit(cadrage);
  }

  onDeleteItem(item: any, cadrage: OperationCadrage): void {
    const items = cadrage.plans.filter((livrable) => livrable.id !== item.id);

    const newCadrage: Update<OperationCadrage> = {
      id: cadrage.id,
      changes: {
        ...cadrage,
        plans: items,
      },
    };

    this.outputUpdate(newCadrage);
  }

  onDeleteAllList(cadrage: OperationCadrage): void {
    const newCadrage: Update<OperationCadrage> = {
      id: cadrage.id,
      changes: {
        ...cadrage,
        plans: [],
      },
    };

    this.outputUpdate(newCadrage);
  }

  onCancel(): void {
    return;
  }
}
